export enum Permissions {
    ReadPatient = "Read Patient",
    WritePatient = "Write Patient",
    ArchivePatient = "Delete Patient (Archive)",
    RegisterPatient = "Register Patient",
    CreateUser = "Create User",
    ArchiveUser = "Delete User (Archive)",
    ConsultationHistoryReadUnrestricted = "Consultation History Module: Read All Unrestricted",
    ConsultationHistoryReadLimited = "Consultation History Module: Read All Limited",
    ConsultationHistoryReadUnrestrictedExceptNotes = "Consultation History Module: Read All (except NOTES)",
    ConsultationHistoryWrite = "Consultation History Module: Write",
    ConsultationHistoryPrivateEpisodeRead = "Private Episodes: Read",
    ConsultationHistoryPrivateEpisodeWrite = "Private Episodes: Write",
    ConsultationHistoryReadPrivateEpisodesUnrestricted = "Private Episodes: Read All",
    ConsultationHistoryWritePrivateEpisodesUnrestricted = "Private Episodes: Write All",
    ReadDiary = "Diary Module: Read",
    WriteDiary = "Diary Module: Write",
    ReadPrescriptions = "Prescriptions Module: Read",
    WritePrescriptions = "Prescriptions Module: Write",
    IRNRead = "IRN Read",
    EditRavenConfig = "Edit Raven Config",
    ReadGroups = "Groups: Read",
    WriteGroups = "Groups: Write",
    ManageOrganisationGrantAccess = "Manage Organisation Grant Access",
    ReadFunctionalGut = "FunctionalGut Read Access",
    WriteFunctionalGut = "FunctionalGut Write Access",
    ManageOrganisationSystemCode = "Manage Organisation Coding System",
    AccessGlobalDRO = "Access GlobalDRO",
    WriteFormsDesign = "Forms Design: Write",
    WriteFormsInstances = "Forms Instances: Write",
    ReadFormsInstances = "Forms Instances: Read",
    WriteIncidents = "Write Incidents",
    ReadNHSData = "Read NHS Data"
}
